module.exports = dibs_buyer_layout;


//////////////////
// WEBPACK FOOTER
// external "dibs_buyer_layout"
// module id = 4276
// module chunks = 63